import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Link,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { GOVBR_AUMENTAR_NIVEL_URL } from '../../utils/govbrNivelAssinatura';

type Props = {
  open: boolean;
  titulo: string;
  onClose: () => void;
};

const useStyles = makeStyles(() => ({
  paper: {
    maxWidth: 560,
    width: '100%',
    borderRadius: 8,
  },
  title: {
    color: '#D32F2F',
    fontFamily: 'Roboto',
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.3,
    marginBottom: 16,
  },
  paragraph: {
    color: '#373F41',
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    marginBottom: 12,
  },
  link: {
    color: '#0F6FB7',
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 400,
    display: 'inline-block',
    marginTop: 4,
    marginBottom: 8,
  },
  actions: {
    padding: '8px 24px 20px',
  },
  okButton: {
    backgroundColor: '#0F6FB7',
    color: '#fff',
    minWidth: 88,
    textTransform: 'none',
    fontFamily: 'Roboto',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#0c5a94',
    },
  },
}));

export default function GovbrNivelInsuficienteDialog({
  open,
  titulo,
  onClose,
}: Props): JSX.Element {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      classes={{ paper: classes.paper }}
      aria-labelledby='govbr-nivel-insuficiente-titulo'
      aria-describedby='govbr-nivel-insuficiente-texto'
      style={{ zIndex: 1500 }}
    >
      <DialogContent>
        <Typography
          id='govbr-nivel-insuficiente-titulo'
          className={classes.title}
          component='h2'
        >
          {titulo}
        </Typography>
        <Box id='govbr-nivel-insuficiente-texto'>
          <Typography className={classes.paragraph}>
            Para realizar a assinatura digital, o nível da sua conta deve ser
            Prata ou Ouro.
          </Typography>
          <Typography className={classes.paragraph}>
            Após atualizar o nível, saia do Portal ms.gov.br, entre novamente
            com sua conta Gov.br e realize a assinatura.
          </Typography>
          <Link
            href={GOVBR_AUMENTAR_NIVEL_URL}
            target='_blank'
            rel='noopener noreferrer'
            className={classes.link}
            underline='always'
          >
            Clique aqui para aumentar o seu nível.
          </Link>
        </Box>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          variant='contained'
          className={classes.okButton}
          onClick={onClose}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
